import type { SettingsResponse } from '../types/api'
import { apiClient } from './client'

export async function getSettings(): Promise<SettingsResponse> {
  return apiClient.get<SettingsResponse>('/settings')
}

export async function listEmbeddingModels(data: {
  apiBaseUrl: string
  apiKey?: string | null
}): Promise<string[]> {
  const response = await apiClient.post<{ models: string[] }>('/embedding/models', data)
  return response.models
}

export async function listLlmModels(data: {
  apiBaseUrl: string
  apiKey?: string | null
  authHeader?: 'authorization_bearer' | 'api_key' | 'none'
}): Promise<string[]> {
  const response = await apiClient.post<{ models: string[] }>('/llm/models', data)
  return response.models
}

export async function listRerankModels(data: {
  apiBaseUrl: string
  apiKey?: string | null
  authHeader?: 'authorization_bearer' | 'api_key' | 'none'
}): Promise<string[]> {
  const response = await apiClient.post<{ models: string[] }>('/rerank/models', data)
  return response.models
}

export interface LlmConnectionTestResult {
  ok: true
  status: number
  latencyMs: number
  jsonMode: 'prompt_only'
  message: string
}

export async function updateSettings(data: {
  embeddingProvider: string
  apiBaseUrl?: string | null
  apiKey?: string | null
  modelName?: string | null
  ragServerBaseUrl?: string | null
  mcpRemoteEnabled?: boolean
  mcpLocalEnabled?: boolean
  restApiEnabled?: boolean
  llmBaseUrl?: string | null
  llmApiKey?: string | null
  llmModelName?: string | null
  llmAuthHeader?: 'authorization_bearer' | 'api_key' | null
  contextualEnrichmentEnabled?: boolean
  transcriptDistillationEnabled?: boolean
  memoryEnabled?: boolean
  textbookPipelineEnabled?: boolean
  rerankEnabled?: boolean
  rerankCandidates?: number
  rerankModel?: string | null
}): Promise<SettingsResponse> {
  return apiClient.put<SettingsResponse>('/settings', data)
}
